import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-play-back-sharp",
  "use": "icon-play-back-sharp-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" class=\"ionicon\" viewBox=\"0 0 512 512\" id=\"icon-play-back-sharp\"><title>Play Back</title><path d=\"M496 400L256 256l240-144v288zM256 400L16 256l240-144v288z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol